import React, { useEffect, useContext, useState } from 'react';
import { Link ,useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc.js';
import {strEncode,strDecode} from '../../encrpt.js';
import DataTable from 'react-data-table-component';
import DatePicker from "react-datepicker"; // Ensure you install react-datepicker
import '../Raportee/datatable.css';
import {API_BASE_URL} from "../../apiConfig.jsx";
import FileUpload from "./file-upload/file-upload.component.jsx";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

function Externe() {
    const navigate = useNavigate();
	const [userData, setUserData] = useState(null);
	useEffect(() => {
		const authToken = localStorage.getItem("authToken");

		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}else
		{
			const storedUser = JSON.parse(localStorage.getItem("user"));
			setUserData(storedUser);
		}
	}, [navigate]);
	const [data, setData] = useState([]);	
	const [columns, setColumns] = useState([]);
	const [tabledata, settableData] = useState([]);	
	const [headingl1, setModalheadingl1] = useState(null);
	const [headingl2, setModalheadingl2] = useState(null);
	const [headingid, setModalheadingid] = useState(null);
	const [modalData, setModalData] = useState([]);
	// State for form fields
	const [formData, setFormData] = useState({
		n_stakeholder_id: headingid || "",
		d_reqdate: new Date(), // Default date
		title: "",
		version: "",
		doc_data: null,
	  });

	  const exportData = (type) => {
		const ws = XLSX.utils.json_to_sheet(tabledata);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };
	
	  const resetForm = () => {
		setFormData({
		  n_stakeholder_id: headingid || "",
		  d_reqdate: new Date(),
		  title: "",
		  version: "",
		  uploadedFile: null,
		});
	  };
	
	
	 
  	 useEffect(() => {
		axios.post(`${API_BASE_URL}/api/getraportee`, { t: strEncode('stakeholder_reporting'),level : strEncode('RAPPORTS EXTERNES')},{ headers: { 'Content-Type': 'application/json' } }) 
          .then( (res) => {
            console.log("res",res.data)
            setData(res.data);
          }).catch( (error) => { console.log(error); });        
    }, []);
   
	useEffect(() => {
		if (modalData.length > 0) { // Ensure modalData contains valid entries
			setFormData(modalData.filter(row => Object.values(row).some(value => value !== "" && value !== null && value !== undefined)));
		}
	}, [modalData]);

	useEffect(() => {
		if (modalData.length > 0) { 
			// Ensure modalData contains valid entries by merging all objects
			const mergedFormData = modalData.flatMap(obj => obj); // Flatten nested arrays if needed	
			setFormData(mergedFormData.filter(row => 
				Object.values(row).some(value => value !== "" && value !== null && value !== undefined)
			));
		}
	}, [modalData]);


    const handleDirectDownload = (filePath) => {
		const anchor = document.createElement("a");
		anchor.href = filePath;
		anchor.download = filePath.split('/').pop(); // Extract filename dynamically
		
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
	
		console.log(`File downloaded: ${anchor.download}`);
	};


	const handleDownloadlogs = async (event, fileId, parentId, action, userId,fileUrl) => {
		event.preventDefault(); // Prevent default link behavior
	     
		 // Prepare log data
		 const logData = {
			file_id: fileId,
			parent_id: parentId,
			action_type: action,
			user_id: userId,
			timestamp: new Date().toISOString(),
		  };
		try {
			  const response = await axios.post(`${API_BASE_URL}/api/doclogs`, 				
				{ logData },
				{ headers: { "Content-Type": "application/json" } }
			  );
               //console.log("fileURL",fileUrl)
			   handleDirectDownload(fileUrl);
		  
			  if (response.status === 200) {
				alert("File Downloaded Successfully")
				console.log("Log created successfully");
				
			  } else {
				console.log("Log created  failed");
			  }
			} catch (error) {
			  console.error("Error created logs:", error);
			 
			}
		  };


		  const handleDelete = async (event, id, parentId, action, userId,fileUrl) => {
			event.preventDefault(); // Prevent default link behavior
			 //	console.log("id",id)
			// Ask for user confirmation before proceeding
			const confirmDelete = window.confirm("Are you sure you want to delete this file?");
			
			if (!confirmDelete) {
			  alert("File deletion cancelled.");
			  return;
			}
		  
			try {
			  const response = await axios.post(`${API_BASE_URL}/api/docs/delete`, 
				{ id },
				{ headers: { "Content-Type": "application/json" } }
			  );
	
			  // Prepare log data
			 const logData = {
				file_id: id,
				parent_id: parentId,
				action_type: action,
				user_id: userId,
				timestamp: new Date().toISOString(),
			  };
			
				  const deletelogs = await axios.post(`${API_BASE_URL}/api/doclogs`, 				
					{ logData },
					{ headers: { "Content-Type": "application/json" } }
				  );
			 
		  
			  if (response.status === 200) {
				alert("File deleted successfully");
				// You may need to update the state or refetch the file list after deletion
			  } else {
				alert("Failed to delete file");
			  }
			} catch (error) {
			  console.error("Error deleting file:", error);
			  alert("An error occurred while deleting the file");
			}
		  };
		  
	const handleModalOpen = (id,level3,level4) => {		
			setModalheadingl1(level3);		 
			setModalheadingl2(level4);		 
			setModalheadingid(id);	
			axios.post(`${API_BASE_URL}/api/docs/getdata`, { t: strEncode('pmis_stakeholders_docs') , n_stakeholder_id: strEncode(id)},{ headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {
					console.log("res",res.data.data)
					 // Check if response data is valid
					if (!res.data || !res.data.data || res.data.data.length === 0) {
						console.warn("Warning: API returned an empty or undefined response.");
						setColumns([]); // Reset columns
						settableData([]); // Reset table data
						return;
					}
					const columnKeys = Object.keys(res.data.data[0]);
					
					const formattedColumns = columnKeys.map((key) => ({
						name: key.charAt(0).toUpperCase() + key.slice(1),
						selector: row => row[key],
						sortable: true,
						cell: (row,index) => {
							if (key === "télécharger") {
							  var uploadDate = new Date(row['Date']);
							  var currentDate = new Date();
							  const daysSinceUpload = Math.floor((currentDate - uploadDate) / (1000 * 60 * 60 * 24));

						      console.log("dayscount",uploadDate)
							  return (
								<div>
								  <a 
									href={`../_repository/${id}/${row.télécharger}`}							
									download={row.télécharger}
									className="btn btn-primary btn-sm"
									onClick={(e) => handleDownloadlogs(e,row['id'],id,"download",userData.id,`../_repository/${id}/${row.télécharger}`)}
									
								  >
									Télécharger
								  </a>
						
								  {daysSinceUpload <= 7 && (
									<button 
									  onClick={() => handleDelete(row.id)}
									  className="btn btn-danger btn-sm"
									>
									  Supprimer
									</button>
								  )}
								</div>
							  );
							}
							return row[key]; // Show normal column data
						  }
					  }));				//console.log("columnKeys",columnKeys)
					setColumns(formattedColumns);
                    settableData(res.data.data);					
				  }).catch(error => {
					console.error("API Error:", error);
				  });
				
				
	};

	  // Handle input changes
	  const handleInputChange = (index, field, value) => {
		setFormData(prevData => {
			const updatedData = [...prevData];
			updatedData[index][field] = value instanceof Date ? value.toISOString().slice(0, 10) : value; // Convert date properly
			return updatedData;
		});
	};

	  // Handle text input change
	  const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	  };
	
	  // Handle date selection
	  const handleDateChange = (date) => {
		setFormData({ ...formData, d_reqdate: date });
	  };
	
	  // Handle file upload
	  const handleFileUpload = (file) => {
		setFormData({ ...formData, uploadedFile: file });
	  };

	  const updateUploadedFiles = (files) => {
		setFormData((prevState) => ({
		  ...prevState,
		  doc_data: files[0], // Assuming single file upload
		}));
	  };
	
	  const handleSubmit = (e) => {
		e.preventDefault();
		const fdata = new FormData();
	  
		fdata.append("n_stakeholder_id", headingid);  // Hidden field value
		fdata.append("title", formData.title);
		fdata.append("version", formData.version);
		fdata.append("d_reqdate", formData.d_reqdate.toISOString().split("T")[0]); // Format date
		fdata.append("n_user_id", userData.id);
		if (formData.doc_data) {
		  fdata.append("c_docfiles", formData.doc_data);
		}
	  
		// Send data to backend via API
		axios.post(`${API_BASE_URL}/api/upload/stakeholdersdocs`, fdata, {
		  headers: { "Content-Type": "multipart/form-data" },
		})
		.then(response => {
			if (response.data.result === "success") {
				alert("Uploaded Successfully")
				// Perform additional actions, like showing a success message or redirecting
				resetForm(); // Reset form data
				closeModal(); // Close the modal
			  } else {
				console.error("Upload failed:", response.data.message);
			  }
	}
			
			)
		.catch(error => console.error("Upload Error:", error));
	  };
	 
	  const closeModal = () => {
		setModalheadingid("");
	   }
	

	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/dashboard/v1">Home</Link></li>
				<li className="breadcrumb-item"><Link to="/dashboard/blank">Raportee</Link></li>
				<li className="breadcrumb-item active">Externe</li>
			</ol>
			<h1 className="page-header">Externes</h1>
			<Panel>
				<PanelHeader>Rapports Externes</PanelHeader>
				<PanelBody>
				<div className="col-xl-12">
				{data.map((item, index) => (
					<div className="accordion" id="accordion">
						<div className="accordion-item border-0">
							<div className="accordion-header" id={"heading"+index}>
								<button className="accordion-button bg-gray-900 text-white px-3 py-10px pointer-cursor" type="button" data-bs-toggle="collapse" 
								data-bs-target={"#collapse"+index}>
									<i className="fa fa-circle fa-fw text-blue me-2 fs-8px"></i> {item.level_2}
								</button>
							</div>
						    <div id={"collapse"+index} className="accordion-collapse collapse" data-bs-parent="#accordion" style={{marginBottom:"2px"}}>
							<div className="accordion-body bg-blue-800 text-white">
							<div className="col-xl-12">
							{item.component.map((items, indexsub) => (
								<div className="accordion" id={"accordion1_" + indexsub}>
									<div className="accordion-item border-0">
									<div className="accordion-header" id={"heading_l3_" + indexsub}>
										<button
										className="accordion-button bg-blue-900 text-white px-3 py-10px pointer-cursor"
										type="button"
										data-bs-toggle="collapse"
										data-bs-target={"#collapse_l3_" + indexsub + "_" + String(items.level_3).replace(/\s/g, '')} // Append level_3 for uniqueness
										>
										<i className="fa fa-circle fa-fw text-blue me-2 fs-8px"></i> {items.level_3}
										</button>
									</div>
									<div
										id={"collapse_l3_" + indexsub + "_" + String(items.level_3).replace(/\s/g, '')} // Unique collapse ID
										className="accordion-collapse collapse"
										data-bs-parent={"#accordion1_" + indexsub} >
										<div className="accordion-body bg-blue-800 text-white">
										 {items.subcomponent.map((itemsub, index) => (
										  <a href="#" 
										     data-bs-toggle="modal" 
										     data-bs-target="#modalPosBooking" 
										     className="pos-table-booking"
										     onClick={() => handleModalOpen(itemsub.id,items.level_3,itemsub.subcomponents)}>
										     <span className="d-sm-block d-none">{itemsub.subcomponents}</span>
									       </a>                            
									      ))}	
										</div>
									</div>
									</div>
								</div>
							))}

           				    </div>							 	
						    </div>
						    </div>
						</div>					
					</div>
					))}	
				</div>
					
				</PanelBody>
			</Panel>
			<div className="modal modal-pos fade" id="modalPosBooking">
				<div className="modal-dialog modal-lg">
					<div className="modal-content border-0">
						<div>
							<div className="p-0">
							<div className="modal-body">
									<div className="d-flex align-items-center mb-3">
										<h6 className="modal-title d-flex align-items-center"><i className="fa fa-bowl-rice fs-2 me-2 my-n1"></i>
										 {headingl1} <i class="fa fa-angle-double-right" aria-hidden="true"></i> 
										 <span style={{color:"blue"}}>{headingl2}</span></h6>
										<a href="/#" data-bs-dismiss="modal" onClick={closeModal} className="ms-auto btn-close">&nbsp;</a>
									</div>
									<div className="row">
									<div className="col-xl-12">
					<ul className="nav nav-tabs">
						<li className="nav-item">
							<a href="#default-tab-modal-1" data-bs-toggle="tab" className="nav-link active">
								<span className="d-sm-block d-none">Liste des documents téléchargés</span>
							</a>
						</li>
						<li className="nav-item">
							<a href="#default-tab-modal-2" data-bs-toggle="tab" className="nav-link">
								<span className="d-sm-block d-none">Télécharger un nouveau document</span>
							</a>
						</li>						
					</ul>
				
					<div className="tab-content panel rounded-0 p-3 m-0">
						<div className="tab-pane fade active show" id="default-tab-modal-1">
						<div>
								<button onClick={() => exportData("xlsx")} className="btn btn-success">
								Exporter Excel
								</button>
							<DataTable
									title="Documents téléchargés"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>
						</div>
							  
						</div>
						<div className="tab-pane fade" id="default-tab-modal-2">
						<form id="smart-form-register" className="smart-form" onSubmit={handleSubmit} noValidate>
										{/* Hidden Input */}
										<input type="hidden" name="n_stakeholder_id" value={headingid} />

										{/* Date Picker */}
										<div className="row form-group" style={{ margin: "5px" }}>
											<div className='col-md-3'>
											<label className='input'>
											<label>Date </label>
											<DatePicker
											className="form-control"
											   disabled
												selected={formData.d_reqdate}
												onChange={handleDateChange}
												dateFormat="yyyy-MM-dd"
											/>
											<b className="tooltip tooltip-bottom-right">Needed to enter the Date</b>
											</label>
											</div>
											<div className='col-md-9'>
											<label className="input" style={{width:"100%"}}>
										<label>Version du document</label>
										<input
											type="text"
											name="version"
											className="form-control"
											placeholder="Version du document"
											required
											value={formData.version}
											onChange={handleChange}
											style={{width:"100%"}}
										/>
										</label> </div>
										</div>						

										{/* Title Input */}
										<div className="row form-group" style={{ margin: "5px" }}>
										
											<label className="input" style={{width:"100%"}}>
											<label>Titre du document</label>
											<input
												type="text"
												name="title"
												className="form-control"
												placeholder="Titre du document"
												required
												value={formData.title}
												onChange={handleChange}
											/>
											</label>
										</div>

										{/* Version Input */}
										{/* File Upload */}
										<span style={{ color: "red", fontStyle: "oblique", fontSize: "14px", fontWeight: "700" }}>
										Seuls les fichiers .pdf, .zip et .docx sont autorisés. Taille maximale : 5 Mo.
										</span>
										<FileUpload accept=".pdf,.zip,.docx" updateFilesCb={updateUploadedFiles} />

										{/* Modal Footer */}
										<div className="modal-footer">
											<button type="button" className="btn btn-sm btn-default" data-dismiss="modal">
											Annuler
											</button>
											<button type="submit" className="btn btn-sm btn-primary">
											Enregistrer le document
											</button>
										</div>
									</form>
						</div>
						</div>
					    </div>
									
									</div>
								</div>
								
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Externe;